<template>
  <Widget>
    <div slot="head" :wrapperWidth="wrapperWidth">
      <span class="whead-left-title"><span style="color:red">{{wTitle}}</span>首页配置</span>
    </div>
    <div slot="toolbar">

    </div>
    <Tabs type="card" slot="content">
      <TabPane :label="tab.name" v-for="(tab,index) in tabList" :key="`tab`+index">
        <config :configName = tab.value></config>
      </TabPane>
    </Tabs>
  </Widget>
</template>
<script>
    import Widget from '@/components/paas/widget';
    import Config from './config.vue'
    export default {
      name: "index",
      components:{Widget,Config},
      data(){
          return{
            tabList:[
              {
                name:"推广轮播图",
                value:"home_poster"
              },
              {
                name:"视频轮播",
                value:"home_video"
              },
              {
                name:"产品分类",
                value:"home_category"
              },
              {
                name:"组合产品",
                value:"home_group_product"
              },
              {
                name:"产品搭配",
                value:"home_product_assortment"
              },
              {
                name:"客户定制",
                value:"custom_made"
              },
              {
                name:"咨询推广图",
                value:"article"
              },
             
             

            ],
        //    serviceUrl:"/eb/system/config",  //每个页面访问后台服务器的路径
            currentIdFiledName: 'id',
            wTitle:'',
            wrapperWidth:'80%',

          }
      },
      created(){
      
      },
      methods:{
      
      }
    }
</script>

<style scoped>

</style>
